var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"video-player"},[_c('video',{ref:"videoPlayer",staticClass:"video-js vjs-theme-city vjs-16-9"})])
}
var staticRenderFns = []

export { render, staticRenderFns }